/* Character preview for wizard step 2: generation, face crop, progress, and the email nudge.
   Loaded by snippets/bajka-wizard-step-preview.liquid. The wizard calls BajkaWizardPreview.attach(). */
(function () {
  var api = null;

  function requireApi() {
    if (!api) throw new Error("BajkaWizardPreview.attach() was not called");
    return api;
  }

  function createPreview(deps) {
    var wizard = deps.wizard;
    var live = deps.live;
    var BAJKA_I18N = deps.i18n;
    var BAJKA_BOOK_LANGUAGE = deps.bookLanguage;
    var BAJKA_SHOP_DOMAIN = deps.shopDomain;
    var bajkaIsMultiCharacter = deps.isMultiCharacter;
    var bajkaCaptureCurrentCharacter = deps.captureCurrentCharacter;
    var bajkaSelectedOption = deps.selectedOption;
    var bajkaAgeValue = deps.ageValue;
    var normalizeGenderSelection = deps.normalizeGender;
    var EYE_COLOR_MAP = deps.eyeColorMap;
    var GENDER_MAP = deps.genderMap;
    var bajkaUploadPhoto = deps.uploadPhoto;
    var bajkaUploadFileRaw = deps.uploadFileRaw;
    var bajkaProductHandle = deps.productHandle;
    var dedicationGenderKey = deps.dedicationGenderKey;

    var FACE_DETECT_ENDPOINT =
      "https://book-api-production-298d.up.railway.app/api/v4-preview/face-detect";
    var PREVIEW_EMAIL_ENDPOINT =
      "https://book-api-production-298d.up.railway.app/api/v4-preview/email";
    var FACE_DETECT_MAX_DIM = 1024;
    var FACE_PAD = 0.4;

    var bajkaLastPreviewImage = "";
    var bajkaLastPreviewRunId = "";
    var bajkaPreviewFingerprintDone = "";
    var bajkaWaitedForPreview = false;
    var bajkaPreviewViewObserver = null;

    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    function bajkaPreviewDisplayUrl(url) {
      if (!url) return url;
      var sep = url.indexOf("?") >= 0 ? "&" : "?";
      return url + sep + "format=jpg&width=768";
    }

    function bajkaPhotoFingerprintPart() {
      var photoEl = wizard.querySelector("#bajka-photo");
      var file = photoEl && photoEl.files && photoEl.files[0];
      if (file) return file.name + ":" + file.size + ":" + file.lastModified;
      if (live.uploadedFor) return live.uploadedFor;
      if (live.preservedPhotoUrl) return "preserved:" + live.preservedPhotoUrl;
      if (live.uploadedKey) return "uploaded:" + live.uploadedKey;
      return "";
    }

    function bajkaPreviewFingerprint() {
      var ids = bajkaPreviewIds() || {};
      if (bajkaIsMultiCharacter()) {
        bajkaCaptureCurrentCharacter();
        return [
          JSON.stringify(
            live.characters.map(function (character) {
              return {
                slotKey: character.slotKey,
                name: character.name,
                gender: character.gender,
                age: character.age,
                hair: character.hair,
                eyes: character.eyes,
                photo:
                  character.uploadedFor ||
                  character.photoUrl ||
                  (character.file
                    ? character.file.name +
                      ":" +
                      character.file.size +
                      ":" +
                      character.file.lastModified
                    : ""),
              };
            }),
          ),
          ids.illustrationId || "",
          JSON.stringify(ids.characters || []),
        ].join("|");
      }
      return [
        bajkaSelectedOption("gender"),
        bajkaAgeValue(),
        bajkaSelectedOption("hair"),
        bajkaSelectedOption("eyes"),
        EYE_COLOR_MAP[bajkaSelectedOption("eyes")] ||
          bajkaSelectedOption("eyes"),
        bajkaPhotoFingerprintPart(),
        ids.illustrationId || "",
        ids.characterId || "",
      ].join("|");
    }

    function bajkaInvalidatePreviewCache() {
      bajkaPreviewFingerprintDone = "";
    }

    function bajkaHasCachedPreview() {
      return !!(
        bajkaLastPreviewImage &&
        bajkaPreviewFingerprintDone &&
        bajkaPreviewFingerprintDone === bajkaPreviewFingerprint()
      );
    }

    function bajkaShowCachedPreview(imageUrl) {
      if (!imageUrl) return;
      bajkaStopProgress();
      bajkaRenderPreviewState(
        '<img class="bajka-preview-img" src="' +
          bajkaPreviewDisplayUrl(imageUrl) +
          '" alt="' +
          esc(BAJKA_I18N.previewAlt) +
          '" />',
      );
      bajkaObservePreviewImage();
      bajkaShowMailNudge("ready");
    }

    function bajkaTryRestoreCachedPreview() {
      if (bajkaHasCachedPreview()) {
        bajkaShowCachedPreview(bajkaLastPreviewImage);
      }
    }

    // Podgląd postaci – klucze: product_handle (personalizowana-ksiazka-*) oraz theme key (space, mermaids, …)
    // Optional third arg { boy, girl } picks a different illustration for the same template.
    var CHARACTER_PREVIEW_MAP = (function () {
      function entry(illustrationId, characterId, gendered) {
        var result = {
          illustrationId: illustrationId,
          characterId: characterId,
        };
        if (gendered && gendered.boy) result.boy = gendered.boy;
        if (gendered && gendered.girl) result.girl = gendered.girl;
        return result;
      }
      var jungleGirl = entry(
        "il-eea6dcf7-ff9a-438b-a0dd-d5df953d2b72",
        "cmfwx60ml0007l504fhnsfpy0",
      );
      var jungleBoy = entry(
        "il-71ad89c9-6e3f-4bdd-ac3f-836bd428dc0d",
        "cmfwx60ml0007l504fhnsfpy0",
      );
      var jungle = entry(jungleBoy.illustrationId, jungleBoy.characterId, {
        boy: jungleBoy,
        girl: jungleGirl,
      });
      var byThemeKey = {
        "birthday-magic": entry(
          "cmmkmnav400c4jm04mxbgbf19",
          "cmmkmn4l9001ejm045uyz4phr",
        ),
        "captain-jack": entry(
          "cmm5m2uhi00c9jj04y205k9js",
          "cmm5m2n1d000ejj04wxgwgtpi",
        ),
        dino: entry("cmadwc2kt00rvjx04nd4pawbn", "cmadwbvwn006gjx04otsezvou"),
        halloween: entry(
          "cmg7t83q500ctl804fqp36hw0",
          "cmg7t7uj20004l804iujiyd7l",
        ),
        "lost-light": entry(
          "il-596d597b-279f-4670-8611-55efcd0afa7e",
          "cmtxepy5g00040agmdsz5togd",
        ),
        "dino-thunder": entry(
          "cmnswkso9007ujy04cimjzv2s",
          "cmnswkp44001njy04ngqz3tue",
        ),
        jungle: jungle,
        "jungle-boy": jungle,
        "jungle-girl": jungle,
        "onkohero-boy": entry(
          "cme8flqk50002l404r91aywvm",
          "cmdr64d4d000clh04dqem40r9",
        ),
        "onkohero-girl": entry(
          "cmgyxpndg00sblb04j8xlp0ss",
          "cmgyxpb1e000qlb04zcckq125",
        ),
        knights: entry(
          "cmads9k6o00gtlb04l1iqm1t2",
          "cmads9g6c004vlb04b2waf1v8",
        ),
        "lost-star": entry(
          "cmhkgnm8f001pju04ztxc6vwf",
          "cmhkgnlfy0012ju04mkcic2ia",
        ),
        "magic-elixir": entry(
          "cmg9fa6qz002sl804dvy5t716",
          "cmg9fa516000tl8040m04lfw5",
        ),
        mermaids: entry(
          "cma52i5qk001lla04ynodvb9w",
          "cma52i4v60008la04s7uuffms",
        ),
        pharaon: entry(
          "cmafb70re0033le04r4mytegl",
          "cmafb6ziv000ile04blwe8c7l",
        ),
        pirates: entry(
          "cmaccwe2b00txjo0468482dhc",
          "cmaccw5wu0004jo04l8rsh1jk",
        ),
        princess: entry(
          "cma3yz028009fju04kmfv8zxn",
          "cma3yyxg8003cju04y7fuuhxd",
        ),
        "princess-frog": entry(
          "il-99a4434d-98f2-4e14-a4e9-2eeb02da8f70",
          "cmou6014g000407jdc9e9u5s3",
        ),
        "school-of-magic": entry(
          "cmaqiip3o00bjl604bjbamm60",
          "cmaqiil1q0008l604ibz4eup2",
        ),
        space: entry("cmab107cl002yl504nkzpy8k7", "cmab105an000tl504uwxev107"),
        "k-pop": entry(
          "il-6adbe105-ea9e-4861-87f0-3041aae19409",
          "cmqatyn3b001704ksmh64gpjp",
        ),
        unicorns: entry(
          "cma59s985008rjx04bm7v37pv",
          "cma59s5mn000gjx04viit86tv",
        ),
      };
      var byHandle = {
        "personalizowana-ksiazka-o-dinozaurach": byThemeKey.dino,
        "personalizowana-ksiazka-o-dzungli": jungle,
        "personalizowana-ksiazka-o-magii-i-eliksirze":
          byThemeKey["magic-elixir"],
        "personalizowana-ksiazka-o-egipcie-i-faraonie": byThemeKey.pharaon,
        "personalizowana-ksiazka-halloween": byThemeKey.halloween,
        "personalizowana-ksiazka-o-jednorozcach": byThemeKey.unicorns,
        "personalizowana-ksiazka-o-kosmosie": byThemeKey.space,
        "personalizowana-ksiazka-o-ksiezniczce": byThemeKey.princess,
        "personalizowana-ksiazka-o-piratach": byThemeKey.pirates,
        "personalizowana-ksiazka-o-piracie-i-pieciu-kluczach":
          byThemeKey["captain-jack"],
        "personalizowana-ksiazka-o-rycerzu-i-smoku": byThemeKey.knights,
        "personalizowana-ksiazka-o-syrence": byThemeKey.mermaids,
        "personalizowana-ksiazka-o-szkole-magii": byThemeKey["school-of-magic"],
        "ksiazeczka-ksiezniczka-i-zakleta-przyjaciolka":
          byThemeKey["princess-frog"],
        "ksiazeczka-ksiezniczka-i-magia-urodzin": byThemeKey["birthday-magic"],
        "personalizowana-ksiazka-o-gwiezdzie-polnocnej":
          byThemeKey["lost-star"],
        "ksiazeczka-k-pop": byThemeKey["k-pop"],
      };
      return Object.assign({}, byThemeKey, byHandle);
    })();

    function bajkaPreviewIds() {
      if (live.characterConfig && live.characterConfig.preview) {
        bajkaCaptureCurrentCharacter();
        var signature = live.characters
          .map(function (character) {
            return GENDER_MAP[normalizeGenderSelection(character.gender)] || "";
          })
          .join("-");
        var configured =
          (live.characterConfig.preview.byGenderSignature &&
            live.characterConfig.preview.byGenderSignature[signature]) ||
          live.characterConfig.preview.default;
        if (configured && configured.illustrationId) {
          if (Array.isArray(configured.characters)) {
            return {
              illustrationId: configured.illustrationId,
              characters: configured.characters.map(function (character) {
                return {
                  slotKey: character.slotKey,
                  characterId: character.characterId,
                };
              }),
            };
          }
          if (configured.characterId) {
            return {
              illustrationId: configured.illustrationId,
              characterId: configured.characterId,
            };
          }
        }
        return null;
      }
      var mapped = null;
      var handle = live.currentHandle || bajkaProductHandle();
      if (handle && CHARACTER_PREVIEW_MAP[handle])
        mapped = CHARACTER_PREVIEW_MAP[handle];

      if (!mapped) {
        var themeKey = (live.currentTheme || "").split(",")[0].trim();
        if (!themeKey) {
          var trigger = document.querySelector(
            "[data-bajka-wizard-open][data-product-theme]",
          );
          themeKey = trigger
            ? (trigger.getAttribute("data-product-theme") || "")
                .split(",")[0]
                .trim()
            : "";
        }
        if (themeKey && CHARACTER_PREVIEW_MAP[themeKey])
          mapped = CHARACTER_PREVIEW_MAP[themeKey];
      }

      if (!mapped) return null;

      var genderKey = dedicationGenderKey();
      var variant = mapped[genderKey];
      if (variant && variant.illustrationId && variant.characterId) {
        return {
          illustrationId: variant.illustrationId,
          characterId: variant.characterId,
        };
      }

      return {
        illustrationId: mapped.illustrationId,
        characterId: mapped.characterId,
      };
    }

    function bajkaRenderPreviewState(html) {
      var out = wizard.querySelector("[data-bajka-preview-out]");
      if (out) out.innerHTML = html;
    }

    function bajkaMailNudge() {
      return wizard.querySelector("[data-bajka-mailnudge]");
    }

    function bajkaMailNudgeSubmitLabel(btn, text) {
      if (btn && text) btn.textContent = text;
    }

    function bajkaMailNudgeMessage(text, variant) {
      var box = bajkaMailNudge();
      var msg = box && box.querySelector("[data-bajka-mailnudge-msg]");
      if (!msg) return;
      msg.classList.remove("bajka-mailnudge__msg--error");
      msg.classList.remove("bajka-mailnudge__msg--success");
      if (!text) {
        msg.textContent = "";
        msg.hidden = true;
        return;
      }
      if (variant) msg.classList.add("bajka-mailnudge__msg--" + variant);
      msg.textContent = text;
      msg.hidden = false;
    }

    // Only offered when there is a run id the backend can resolve into an image.
    // Previews restored from a cart line carry an image but no run id.
    // mode: "waiting" while the render is still generating (notify-when-ready),
    // "ready" once the image is on screen (send/share now).
    var bajkaMailNudgeMode = "ready";
    var bajkaMailNudgeSent = false;

    function bajkaMailNudgeCopy(mode) {
      var waiting = mode === "waiting";
      return {
        title: waiting
          ? BAJKA_I18N.previewEmailTitleWaiting || BAJKA_I18N.previewEmailTitle
          : BAJKA_I18N.previewEmailTitle,
        submit: waiting
          ? BAJKA_I18N.previewEmailSubmitWaiting ||
            BAJKA_I18N.previewEmailSubmit
          : BAJKA_I18N.previewEmailSubmit,
        success: waiting
          ? BAJKA_I18N.previewEmailSuccessWaiting ||
            BAJKA_I18N.previewEmailSuccess
          : BAJKA_I18N.previewEmailSuccess,
      };
    }

    function bajkaShowMailNudge(mode) {
      var box = bajkaMailNudge();
      if (!box) return;
      if (!bajkaLastPreviewRunId) {
        box.hidden = true;
        return;
      }
      bajkaMailNudgeMode = mode === "waiting" ? "waiting" : "ready";
      box.hidden = false;
      var copy = bajkaMailNudgeCopy(bajkaMailNudgeMode);
      var title = box.querySelector("[data-bajka-mailnudge-title]");
      if (title) title.textContent = copy.title;
      var btn = box.querySelector("[data-bajka-mailnudge-submit]");
      // Keep the sent label/message if the visitor already opted in during the wait.
      if (btn && !bajkaMailNudgeSent) {
        bajkaMailNudgeSubmitLabel(btn, copy.submit);
      }
    }

    function bajkaResetMailNudge() {
      var box = bajkaMailNudge();
      if (!box) return;
      box.hidden = true;
      bajkaMailNudgeMode = "ready";
      bajkaMailNudgeSent = false;
      var title = box.querySelector("[data-bajka-mailnudge-title]");
      if (title) title.textContent = BAJKA_I18N.previewEmailTitle;
      var input = box.querySelector("#bajka-preview-email");
      if (input) input.value = "";
      var consent = box.querySelector("[data-bajka-mailnudge-consent]");
      if (consent) consent.checked = false;
      var btn = box.querySelector("[data-bajka-mailnudge-submit]");
      if (btn) {
        btn.disabled = false;
        bajkaMailNudgeSubmitLabel(btn, BAJKA_I18N.previewEmailSubmit);
      }
      bajkaMailNudgeMessage("");
    }

    function bajkaEmailLooksValid(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
    }

    function bajkaClientRequestId() {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
      return (
        "bajka-mail-" + Date.now() + "-" + Math.random().toString(36).slice(2)
      );
    }

    // Everything the wizard would otherwise lose when the visitor leaves. The
    // render job knows only the illustration and the face, so name, hair, eyes
    // and the book itself have to travel with the email request or the link in
    // that email cannot restore anything. Without a photo key there is nothing
    // worth resuming, so the snapshot is dropped and the email gets a plain link.
    function bajkaResumeSnapshot() {
      if (bajkaIsMultiCharacter()) {
        bajkaCaptureCurrentCharacter();
        if (
          !live.characters.length ||
          live.characters.some(function (character) {
            return !(character.uploadedKey || character.photoUrl);
          })
        ) {
          return null;
        }
        return {
          version: 2,
          productHandle: live.currentHandle || bajkaProductHandle(),
          productTheme: live.currentTheme || "",
          productTitle: live.productTitle,
          characters: live.characters.map(function (character) {
            return {
              slotKey: character.slotKey,
              name: character.name,
              gender: character.gender,
              age: character.age,
              hair: character.hair,
              eyes: character.eyes,
              photoKey: character.uploadedKey || character.photoUrl,
              photoName: character.photoName || BAJKA_I18N.photo,
            };
          }),
        };
      }
      var photoKey = live.uploadedKey || live.preservedPhotoUrl || "";
      if (!photoKey) return null;
      var nameInput = wizard.querySelector("#bajka-name");
      return {
        name: (nameInput && nameInput.value.trim()) || "",
        gender: bajkaSelectedOption("gender"),
        age: bajkaAgeValue(),
        hair: bajkaSelectedOption("hair"),
        eyes: bajkaSelectedOption("eyes"),
        photoKey: photoKey,
        productHandle: live.currentHandle || bajkaProductHandle(),
        productTheme: live.currentTheme || "",
        productTitle: live.productTitle,
      };
    }

    // Sends the run id, never the image URL: the backend resolves the image from
    // its own render record so the endpoint cannot be used as an open relay.
    function bajkaSubmitPreviewEmail(email) {
      var nameInput = wizard.querySelector("#bajka-name");
      var childName = (nameInput && nameInput.value.trim()) || "";
      if (bajkaIsMultiCharacter()) {
        bajkaCaptureCurrentCharacter();
        childName = live.characters
          .map(function (character) {
            return character.name;
          })
          .filter(Boolean)
          .join(" i ");
      }
      var payload = {
        email: email,
        runId: bajkaLastPreviewRunId,
        marketingConsent: true,
        locale: BAJKA_BOOK_LANGUAGE,
        shopifyDomain: BAJKA_SHOP_DOMAIN,
        clientRequestId: bajkaClientRequestId(),
        childName: childName,
      };
      var resume = bajkaResumeSnapshot();
      if (resume) payload.resume = resume;
      return window.ChildbookStorefrontSession.fetch(PREVIEW_EMAIL_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).then(function (response) {
        if (response.ok) return;
        return response
          .json()
          .catch(function () {
            return null;
          })
          .then(function (data) {
            throw new Error(
              "preview email rejected: " +
                ((data && data.errorCode) || response.status),
            );
          });
      });
    }

    (function bindMailNudge() {
      var box = bajkaMailNudge();
      var btn = box && box.querySelector("[data-bajka-mailnudge-submit]");
      if (!btn) return;

      btn.addEventListener("click", function () {
        var input = box.querySelector("#bajka-preview-email");
        var consent = box.querySelector("[data-bajka-mailnudge-consent]");
        var email = ((input && input.value) || "").trim();

        if (!bajkaEmailLooksValid(email)) {
          bajkaMailNudgeMessage(BAJKA_I18N.previewEmailInvalid, "error");
          if (input) input.focus();
          return;
        }
        // Consent gates the send outright: no tick, no email.
        if (!consent || !consent.checked) {
          bajkaMailNudgeMessage(
            BAJKA_I18N.previewEmailConsentRequired,
            "error",
          );
          return;
        }

        btn.disabled = true;
        bajkaMailNudgeSubmitLabel(btn, BAJKA_I18N.previewEmailSending);
        bajkaMailNudgeMessage(BAJKA_I18N.previewEmailSending);
        bajkaSubmitPreviewEmail(email)
          .then(function () {
            var copy = bajkaMailNudgeCopy(bajkaMailNudgeMode);
            bajkaMailNudgeSent = true;
            bajkaMailNudgeSubmitLabel(btn, BAJKA_I18N.previewEmailSent);
            bajkaMailNudgeMessage(copy.success, "success");
            if (input) input.value = "";
          })
          .catch(function (err) {
            if (window.console && err) {
              try {
                console.warn(
                  "[bajka] Preview email failed:",
                  err && err.message ? err.message : err,
                );
              } catch (e) {}
            }
            bajkaMailNudgeMessage(BAJKA_I18N.previewEmailError, "error");
            bajkaMailNudgeSubmitLabel(
              btn,
              bajkaMailNudgeCopy(bajkaMailNudgeMode).submit,
            );
            btn.disabled = false;
          });
      });
    })();

    function bajkaObservePreviewImage() {
      var out = wizard.querySelector("[data-bajka-preview-out]");
      var image = out && out.querySelector(".bajka-preview-img");
      if (!image || !("IntersectionObserver" in window)) return;
      if (bajkaPreviewViewObserver) bajkaPreviewViewObserver.disconnect();

      var isVisible = false;
      function markPreviewAsSeen() {
        if (!isVisible || !image.complete || !image.naturalWidth) return;
        bajkaWaitedForPreview = true;
        if (bajkaPreviewViewObserver) {
          bajkaPreviewViewObserver.disconnect();
          bajkaPreviewViewObserver = null;
        }
      }

      bajkaPreviewViewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === image && entry.isIntersecting) {
            isVisible = true;
            markPreviewAsSeen();
          }
        });
      });
      bajkaPreviewViewObserver.observe(image);
      image.addEventListener("load", markPreviewAsSeen, { once: true });
      markPreviewAsSeen();
    }

    // Progress bar 0–100 % over 75 s, as long as the preview image has not arrived yet.
    var bajkaProgressTimer = null;
    var bajkaProgressBar = null;
    var bajkaProgressLabel = null;
    var bajkaProgressSetReal = function () {}; // no-op (eta/progress from the API too unreliable)
    function bajkaStopProgress() {
      if (bajkaProgressTimer) {
        clearInterval(bajkaProgressTimer);
        bajkaProgressTimer = null;
      }
    }
    // Bild ist fertig: Balken zuegig auf 100 % fuellen, dann Callback (Bild zeigen).
    function bajkaCompleteProgress(done) {
      bajkaStopProgress();
      if (bajkaProgressBar) bajkaProgressBar.style.width = "100%";
      if (bajkaProgressLabel) bajkaProgressLabel.textContent = "100 %";
      setTimeout(function () {
        if (typeof done === "function") done();
      }, 380);
    }
    function bajkaStartProgress() {
      bajkaStopProgress();
      bajkaRenderPreviewState(
        '<div class="bajka-progress-wrap">' +
          '<div class="bajka-progress">' +
          '<div class="bajka-progress__track"><div class="bajka-progress__fill" data-bajka-progress-bar></div></div>' +
          '<span class="bajka-progress__label" data-bajka-progress-label>0 %</span>' +
          "</div>" +
          '<div class="bajka-progress-trust">' +
          '<svg class="bajka-progress-trust__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M9 18h6M10 21h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.2 1 2v.3h6v-.3c0-.8.4-1.5 1-2A7 7 0 0 0 12 2Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
          "</svg>" +
          '<div class="bajka-progress-trust__body">' +
          '<p class="bajka-progress-trust__title">' +
          esc(BAJKA_I18N.didYouKnow) +
          "</p>" +
          '<p class="bajka-progress-trust__text">' +
          esc(BAJKA_I18N.progressTrust) +
          "</p>" +
          "</div>" +
          "</div>" +
          "</div>",
      );
      var out = wizard.querySelector("[data-bajka-preview-out]");
      bajkaProgressBar = out && out.querySelector("[data-bajka-progress-bar]");
      bajkaProgressLabel =
        out && out.querySelector("[data-bajka-progress-label]");
      // Smoothly decelerating progress towards a soft ceiling (~96 %):
      // schnell am Anfang, traeger gegen Ende, erreicht NIE von selbst 100 %.
      // The jump to 100 % is done by bajkaCompleteProgress() only when the image has arrived.
      var CAP = 96;
      var TAU = 22000; // Zeitkonstante (groesser = langsamer)
      var start = Date.now();
      var shown = 0;
      bajkaProgressTimer = setInterval(function () {
        var elapsed = Date.now() - start;
        var target = CAP * (1 - Math.exp(-elapsed / TAU));
        if (shown < target) {
          shown += Math.max(0.25, (target - shown) * 0.15);
          if (shown > target) shown = target;
        }
        if (bajkaProgressBar) bajkaProgressBar.style.width = shown + "%";
        if (bajkaProgressLabel)
          bajkaProgressLabel.textContent = Math.round(shown) + " %";
      }, 120);
    }

    // ---- Auto-crop to face (+ selection when multiple faces are detected) ----
    // Erkennt Koepfe via face-detect. 0 Treffer -> Original. 1 -> still mit Padding
    // crop. Multiple -> selection thumbnails, user picks. Error/CORS -> original.
    function bajkaLoadImage(file) {
      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          resolve({ img: img, url: url });
        };
        img.onerror = function () {
          try {
            URL.revokeObjectURL(url);
          } catch (e) {}
          reject(new Error(BAJKA_I18N.loadPhotoError));
        };
        img.src = url;
      });
    }
    function bajkaImageToDataUrl(img, maxDim) {
      var w = img.naturalWidth,
        h = img.naturalHeight;
      var scale = Math.min(1, maxDim / Math.max(w, h));
      var c = document.createElement("canvas");
      c.width = Math.max(1, Math.round(w * scale));
      c.height = Math.max(1, Math.round(h * scale));
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      return c.toDataURL("image/jpeg", 0.85);
    }
    function bajkaDetectAllHeads(dataUrl) {
      return window.ChildbookStorefrontSession.fetch(FACE_DETECT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ image_url: dataUrl, object: "head" }),
      })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          var arr = (data && data.objects) || [];
          return arr.filter(function (b) {
            return (
              b &&
              isFinite(b.x_min) &&
              isFinite(b.y_min) &&
              isFinite(b.x_max) &&
              isFinite(b.y_max) &&
              b.x_max > b.x_min &&
              b.y_max > b.y_min
            );
          });
        })
        .catch(function () {
          return [];
        });
    }
    function bajkaPaddedCropCanvas(img, box, pad) {
      var W = img.naturalWidth,
        H = img.naturalHeight;
      var bw = box.x_max - box.x_min,
        bh = box.y_max - box.y_min;
      if (bw <= 0 || bh <= 0) return null;
      var x0 = Math.max(0, box.x_min - bw * pad);
      var y0 = Math.max(0, box.y_min - bh * pad);
      var x1 = Math.min(1, box.x_max + bw * pad);
      var y1 = Math.min(1, box.y_max + bh * pad);
      var sx = Math.round(x0 * W),
        sy = Math.round(y0 * H);
      var sw = Math.round((x1 - x0) * W),
        sh = Math.round((y1 - y0) * H);
      if (sw < 16 || sh < 16) return null;
      var c = document.createElement("canvas");
      c.width = sw;
      c.height = sh;
      c.getContext("2d").drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
      return c;
    }
    function bajkaCropBoxToFile(img, box) {
      var c = bajkaPaddedCropCanvas(img, box, FACE_PAD);
      if (!c) return Promise.resolve(null);
      return new Promise(function (resolve) {
        if (c.toBlob) {
          c.toBlob(
            function (blob) {
              if (!blob) {
                resolve(null);
                return;
              }
              try {
                resolve(new File([blob], "crop.jpg", { type: "image/jpeg" }));
              } catch (e) {
                try {
                  blob.name = "crop.jpg";
                } catch (e2) {}
                resolve(blob);
              }
            },
            "image/jpeg",
            0.92,
          );
        } else {
          resolve(null);
        }
      });
    }
    function bajkaBoxThumb(img, box, size) {
      var c = bajkaPaddedCropCanvas(img, box, FACE_PAD);
      if (!c) return "";
      var t = document.createElement("canvas");
      var scale = size / Math.max(c.width, c.height);
      t.width = Math.max(1, Math.round(c.width * scale));
      t.height = Math.max(1, Math.round(c.height * scale));
      t.getContext("2d").drawImage(c, 0, 0, t.width, t.height);
      return t.toDataURL("image/jpeg", 0.8);
    }
    function bajkaDetectFaces(file) {
      if (!file || !/^image\//.test(file.type || "")) {
        return Promise.resolve({ img: null, url: null, boxes: [], file: file });
      }
      return bajkaLoadImage(file)
        .then(function (loaded) {
          return bajkaDetectAllHeads(
            bajkaImageToDataUrl(loaded.img, FACE_DETECT_MAX_DIM),
          ).then(function (boxes) {
            return {
              img: loaded.img,
              url: loaded.url,
              boxes: boxes,
              file: file,
            };
          });
        })
        .catch(function () {
          return { img: null, url: null, boxes: [], file: file };
        });
    }
    function bajkaReleaseResult(result) {
      if (result && result.url) {
        try {
          URL.revokeObjectURL(result.url);
        } catch (e) {}
      }
    }
    function bajkaShowPreviewError() {
      bajkaStopProgress();
      bajkaResetMailNudge();
      bajkaRenderPreviewState(
        '<div class="bajka-preview-errorbox" role="alert">' +
          '<span class="bajka-preview-errorbox__icon" aria-hidden="true">⚠️</span>' +
          '<div class="bajka-preview-errorbox__text">' +
          "<strong>" +
          esc(BAJKA_I18N.previewImpossible) +
          "</strong>" +
          "<span>" +
          esc(BAJKA_I18N.previewTryAnother) +
          "</span>" +
          "</div>" +
          "</div>",
      );
    }

    function bajkaRunPreviewRequest(data) {
      if (!bajkaProgressTimer) bajkaStartProgress();
      bajkaResetMailNudge();
      var preview = document.createElement("character-preview");
      document.body.appendChild(preview);
      preview.addEventListener("character-preview:queued", function (e) {
        var runId = (e.detail && e.detail.runId) || preview.lastRunId || "";
        if (!runId) return;
        bajkaLastPreviewRunId = runId;
        // Backend accepts pending/running runs and emails when the image lands.
        bajkaShowMailNudge("waiting");
      });
      preview.addEventListener("character-preview:progress", function (e) {
        bajkaProgressSetReal(e.detail);
      });
      data.skipCaptcha = true;
      preview.data = data;
      return preview
        .requestPhoto()
        .then(function (imageUrl) {
          var runId = preview.lastRunId || bajkaLastPreviewRunId || "";
          try {
            preview.remove();
          } catch (e) {}
          bajkaLastPreviewImage = imageUrl || "";
          bajkaLastPreviewRunId = runId;
          bajkaPreviewFingerprintDone = bajkaPreviewFingerprint();
          bajkaCompleteProgress(function () {
            bajkaRenderPreviewState(
              '<img class="bajka-preview-img" src="' +
                bajkaPreviewDisplayUrl(imageUrl) +
                '" alt="' +
                esc(BAJKA_I18N.previewAlt) +
                '" />',
            );
            bajkaObservePreviewImage();
            bajkaShowMailNudge("ready");
          });
        })
        .catch(function (err) {
          try {
            preview.remove();
          } catch (e) {}
          throw new Error(
            BAJKA_I18N.previewApi +
              " " +
              (err && err.message ? err.message : err),
          );
        });
    }

    function bajkaRunPreviewWithFaceKey(key, ids) {
      return bajkaRunPreviewRequest({
        illustrationId: ids.illustrationId,
        characterId: ids.characterId,
        faceUrl: key,
        eyeColor:
          EYE_COLOR_MAP[bajkaSelectedOption("eyes")] ||
          bajkaSelectedOption("eyes"),
        age: Number(
          wizard.querySelector("#bajka-age") &&
            wizard.querySelector("#bajka-age").value,
        ),
        gender:
          GENDER_MAP[normalizeGenderSelection(bajkaSelectedOption("gender"))] ||
          "",
      });
    }

    function bajkaCropAndRun(result, box, ids) {
      bajkaStartProgress();
      var cropPromise =
        box && result.img
          ? bajkaCropBoxToFile(result.img, box)
          : Promise.resolve(null);
      cropPromise
        .then(function (cropped) {
          bajkaReleaseResult(result);
          return bajkaUploadPhoto(cropped || result.file);
        })
        .then(function (key) {
          return bajkaRunPreviewWithFaceKey(key, ids);
        })
        .catch(function (err) {
          if (window.console && err) {
            try {
              console.warn(
                "[bajka] Preview failed:",
                err && err.message ? err.message : err,
              );
            } catch (e) {}
          }
          bajkaShowPreviewError();
        });
    }
    function bajkaShowFacePicker(result, ids) {
      var boxes = result.boxes;
      var html =
        '<div class="bajka-facepick">' +
        '<p class="bajka-facepick__title">' +
        esc(BAJKA_I18N.facePickerTitle) +
        "</p>" +
        '<div class="bajka-facepick__grid">';
      for (var i = 0; i < boxes.length; i++) {
        html +=
          '<button type="button" class="bajka-facepick__item" data-bajka-face="' +
          i +
          '">' +
          '<img src="' +
          bajkaBoxThumb(result.img, boxes[i], 240) +
          '" alt="' +
          esc(BAJKA_I18N.faceN.replace("__N__", String(i + 1))) +
          '" />' +
          "</button>";
      }
      html += "</div></div>";
      bajkaRenderPreviewState(html);
      var out = wizard.querySelector("[data-bajka-preview-out]");
      var picked = false;
      out.querySelectorAll("[data-bajka-face]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (picked) return;
          picked = true;
          out.querySelectorAll("[data-bajka-face]").forEach(function (b) {
            b.disabled = true;
          });
          btn.classList.add("bajka-facepick__item--selected");
          btn.setAttribute("aria-pressed", "true");
          bajkaCropAndRun(
            result,
            boxes[Number(btn.getAttribute("data-bajka-face"))],
            ids,
          );
        });
      });
    }

    function bajkaPickCharacterFace(result, character) {
      return new Promise(function (resolve, reject) {
        var boxes = result.boxes || [];
        var html =
          '<div class="bajka-facepick">' +
          '<p class="bajka-facepick__title">' +
          esc(
            BAJKA_I18N.facePickerTitle +
              (character.name ? " — " + character.name : ""),
          ) +
          "</p>" +
          '<div class="bajka-facepick__grid">';
        for (var i = 0; i < boxes.length; i++) {
          html +=
            '<button type="button" class="bajka-facepick__item" data-bajka-face="' +
            i +
            '"><img src="' +
            bajkaBoxThumb(result.img, boxes[i], 240) +
            '" alt="' +
            esc(BAJKA_I18N.faceN.replace("__N__", String(i + 1))) +
            '" /></button>';
        }
        html += "</div></div>";
        bajkaRenderPreviewState(html);
        var out = wizard.querySelector("[data-bajka-preview-out]");
        var picked = false;
        out.querySelectorAll("[data-bajka-face]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            if (picked) return;
            picked = true;
            out
              .querySelectorAll("[data-bajka-face]")
              .forEach(function (button) {
                button.disabled = true;
              });
            btn.classList.add("bajka-facepick__item--selected");
            bajkaCropBoxToFile(
              result.img,
              boxes[Number(btn.getAttribute("data-bajka-face"))],
            )
              .then(function (cropped) {
                bajkaReleaseResult(result);
                resolve(cropped || result.file);
              })
              .catch(function (error) {
                bajkaReleaseResult(result);
                reject(error);
              });
          });
        });
      });
    }

    function bajkaPrepareCharacterPhoto(character) {
      var file = character && character.file;
      if (!character)
        return Promise.reject(new Error(BAJKA_I18N.uploadPhotoFirst));
      if (!file && (character.uploadedKey || character.photoUrl)) {
        character.uploadedKey = character.uploadedKey || character.photoUrl;
        character.uploadedFor =
          character.uploadedFor || "preserved:" + character.uploadedKey;
        return Promise.resolve(character.uploadedKey);
      }
      if (!file) return Promise.reject(new Error(BAJKA_I18N.uploadPhotoFirst));

      var signature = file.name + ":" + file.size + ":" + file.lastModified;
      if (character.uploadedKey && character.uploadedFor === signature) {
        return Promise.resolve(character.uploadedKey);
      }

      bajkaRenderPreviewState(
        '<span class="bajka-preview-loading">' +
          esc(
            BAJKA_I18N.analysingPhoto +
              (character.name ? " — " + character.name : ""),
          ) +
          "</span>",
      );
      return bajkaDetectFaces(file)
        .then(function (result) {
          if (result.boxes.length > 1)
            return bajkaPickCharacterFace(result, character);
          var cropPromise =
            result.boxes.length && result.img
              ? bajkaCropBoxToFile(result.img, result.boxes[0])
              : Promise.resolve(null);
          return cropPromise.then(function (cropped) {
            bajkaReleaseResult(result);
            return cropped || result.file;
          });
        })
        .then(function (preparedFile) {
          return bajkaUploadFileRaw(preparedFile);
        })
        .then(function (key) {
          character.uploadedKey = key;
          character.uploadedFor = signature;
          return key;
        });
    }

    function bajkaRunMultiPreview(ids) {
      var replacements = live.characterConfig.slots.map(function (slot) {
        var character = live.characters.find(function (candidate) {
          return candidate.slotKey === slot.key;
        });
        var mapping = ids.characters.find(function (candidate) {
          return candidate.slotKey === slot.key;
        });
        if (!character || !mapping || !character.uploadedKey) return null;
        return {
          characterId: mapping.characterId,
          faceUrl: character.uploadedKey,
          eyeColor: EYE_COLOR_MAP[character.eyes] || character.eyes,
          age: Number(character.age),
          gender: GENDER_MAP[normalizeGenderSelection(character.gender)] || "",
        };
      });
      if (
        replacements.some(function (replacement) {
          return !replacement;
        })
      ) {
        return Promise.reject(new Error(BAJKA_I18N.previewUnavailable));
      }
      return bajkaRunPreviewRequest({
        illustrationId: ids.illustrationId,
        replacements: replacements,
      });
    }

    function bajkaGenerateMultiPreview(ids) {
      bajkaCaptureCurrentCharacter();
      bajkaLastPreviewRunId = "";
      bajkaResetMailNudge();
      bajkaStartProgress();
      var sequence = Promise.resolve();
      live.characters.forEach(function (character) {
        sequence = sequence.then(function () {
          return bajkaPrepareCharacterPhoto(character);
        });
      });
      return sequence
        .then(function () {
          return bajkaRunMultiPreview(ids);
        })
        .catch(function (err) {
          if (window.console && err) {
            try {
              console.warn(
                "[bajka] Multi-character preview failed:",
                err && err.message ? err.message : err,
              );
            } catch (e) {}
          }
          bajkaShowPreviewError();
        });
    }

    function bajkaGeneratePreview() {
      if (bajkaIsMultiCharacter()) {
        var multiIds = bajkaPreviewIds();
        if (!multiIds || !Array.isArray(multiIds.characters)) {
          bajkaRenderPreviewState(esc(BAJKA_I18N.previewUnavailable));
          return;
        }
        bajkaGenerateMultiPreview(multiIds);
        return;
      }
      var photoInputEl = wizard.querySelector("#bajka-photo");
      var file = photoInputEl && photoInputEl.files && photoInputEl.files[0];

      // A new render invalidates the previous one, so the nudge must not stay
      // up offering to email a run id that no longer matches what is on screen.
      bajkaLastPreviewRunId = "";
      bajkaResetMailNudge();

      var ids = bajkaPreviewIds();
      if (!ids) {
        bajkaRenderPreviewState(esc(BAJKA_I18N.previewUnavailable));
        return;
      }

      if (!file && live.uploadedKey) {
        bajkaRunPreviewWithFaceKey(live.uploadedKey, ids).catch(function (err) {
          if (window.console && err) {
            try {
              console.warn(
                "[bajka] Preview failed:",
                err && err.message ? err.message : err,
              );
            } catch (e) {}
          }
          bajkaShowPreviewError();
        });
        return;
      }

      if (!file) {
        bajkaRenderPreviewState(esc(BAJKA_I18N.uploadPhotoFirst));
        return;
      }

      bajkaRenderPreviewState(
        '<span class="bajka-preview-loading">' +
          esc(BAJKA_I18N.analysingPhoto) +
          "</span>",
      );
      bajkaDetectFaces(file).then(function (result) {
        if (result.boxes.length > 1) {
          bajkaShowFacePicker(result, ids);
        } else {
          bajkaCropAndRun(result, result.boxes[0] || null, ids);
        }
      });
    }

    return {
      invalidateCache: bajkaInvalidatePreviewCache,
      hasCached: bajkaHasCachedPreview,
      tryRestoreCached: bajkaTryRestoreCachedPreview,
      showCached: function () {
        bajkaShowCachedPreview(bajkaLastPreviewImage);
      },
      generate: bajkaGeneratePreview,
      reset: function () {
        bajkaLastPreviewImage = "";
        bajkaLastPreviewRunId = "";
        bajkaResetMailNudge();
        bajkaPreviewFingerprintDone = "";
        bajkaWaitedForPreview = false;
        if (bajkaPreviewViewObserver) {
          bajkaPreviewViewObserver.disconnect();
          bajkaPreviewViewObserver = null;
        }
      },
      lastImage: function () {
        return bajkaLastPreviewImage;
      },
      waitedForPreview: function () {
        return bajkaWaitedForPreview;
      },
      adoptSaved: function (saved) {
        bajkaLastPreviewImage = (saved && saved.image) || "";
        bajkaLastPreviewRunId = (saved && saved.runId) || "";
        if (saved && typeof saved.waited === "boolean")
          bajkaWaitedForPreview = saved.waited;
        bajkaPreviewFingerprintDone = bajkaLastPreviewImage
          ? bajkaPreviewFingerprint()
          : "";
      },
    };
  }

  window.BajkaWizardPreview = {
    attach: function (deps) {
      api = createPreview(deps);
    },
    invalidateCache: function () {
      requireApi().invalidateCache();
    },
    hasCached: function () {
      return requireApi().hasCached();
    },
    tryRestoreCached: function () {
      requireApi().tryRestoreCached();
    },
    showCached: function () {
      requireApi().showCached();
    },
    generate: function () {
      requireApi().generate();
    },
    reset: function () {
      requireApi().reset();
    },
    lastImage: function () {
      return requireApi().lastImage();
    },
    waitedForPreview: function () {
      return requireApi().waitedForPreview();
    },
    adoptSaved: function (saved) {
      requireApi().adoptSaved(saved);
    },
  };
})();
